// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"5775c683","692":"0f6575d0","700":"3deb0d15","848":"76f7f3f6"}[chunkId] + ".chunk.css";
};